
    // Nav scroll & toggle functionality
function scrollToId(id) {
  var links = document.getElementById("navLinks");
  var btn = document.getElementById("mobBtn");
  if (links) links.classList.remove("open");
  if (btn) {
    btn.classList.remove("open");
    btn.setAttribute("aria-expanded", "false");
  }
  document.body.style.overflow = "";
  if (id === "quote") {
    var formWrap = document.getElementById("q-form-wrap");
    if (formWrap) {
      formWrap.scrollIntoView({ behavior: "smooth", block: "center" });
      formWrap.classList.add("form-guide-highlight");
      setTimeout(function () {
        formWrap.classList.remove("form-guide-highlight");
      }, 5000);
      formWrap.addEventListener(
        "focusin",
        function removeGuide() {
          formWrap.classList.remove("form-guide-highlight");
          formWrap.removeEventListener("focusin", removeGuide);
        },
        { once: true },
      );
    }
  } else {
    var el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  }
}

function toggleNav() {
  var links = document.getElementById("navLinks");
  var btn = document.getElementById("mobBtn");
  if (!links || !btn) return;
  var isOpen = links.classList.toggle("open");
  btn.classList.toggle("open", isOpen);
  btn.setAttribute("aria-expanded", isOpen ? "true" : "false");
  document.body.style.overflow = isOpen ? "hidden" : "";
}

document.addEventListener("click", function (e) {
  var links = document.getElementById("navLinks");
  var btn = document.getElementById("mobBtn");
  if (!links || !btn) return;
  // Defer so the same tap that opened the menu isn't treated as "outside"
  setTimeout(function () {
    if (!links.classList.contains("open")) return;
    var target = e.target;
    if (links.contains(target) || btn.contains(target)) return;
    links.classList.remove("open");
    btn.classList.remove("open");
    btn.setAttribute("aria-expanded", "false");
    document.body.style.overflow = "";
  }, 0);
});

var _lastScrollY = window.scrollY || 0;
window.addEventListener(
  "scroll",
  function () {
    var links = document.getElementById("navLinks");
    var btn = document.getElementById("mobBtn");
    if (!links || !btn || !links.classList.contains("open")) return;
    if (Math.abs(window.scrollY - _lastScrollY) > 40) {
      links.classList.remove("open");
      btn.classList.remove("open");
      btn.setAttribute("aria-expanded", "false");
      document.body.style.overflow = "";
    }
    _lastScrollY = window.scrollY;
  },
  { passive: true },
);
